import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../../Store';

export default function AgentRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  // The agent portal is the single staff shell. Any staff member — agent,
  // user manager or product manager — lands here; the sidebar and each
  // endpoint decide what they can actually see and do.
  const isStaff =
    userInfo &&
    (userInfo.isAgent ||
      userInfo.isUserManager ||
      userInfo.isProductManager ||
      userInfo.isAdmin);
  return isStaff ? children : <Navigate to="/signin" />;
}
